/**
 * 採用ページの「新卒採用」と「中途採用」タブ切り替え
 */
import gsap from 'gsap';

export const recruitTabs = {
  init: () => {
    const navList = document.querySelector(
      '.page-recruit-selection-process__nav__list'
    );
    const navLinks = navList
      ? navList.querySelectorAll('.page-recruit-selection-process__nav__list__item')
      : [];
    const ngRecruit = document.getElementById('new-graduate-recruitment');
    const expRecruit = document.getElementById('experienced-recruitment');

    if (!navLinks.length || !ngRecruit || !expRecruit) return;

    const sections = [ngRecruit as HTMLElement, expRecruit as HTMLElement];

    const setActive = (index: number, animate = true) => {
      navLinks.forEach((li, i) => {
        if (i === index) {
          li.classList.add('--active');
        } else {
          li.classList.remove('--active');
        }
      });

      const showEl = sections[index];
      const hideEl = sections[index === 0 ? 1 : 0];

      hideEl.style.display = 'none';

      showEl.style.display = '';

      if (animate) {
        gsap.fromTo(
          showEl,
          { opacity: 0, y: 5 },
          {
            opacity: 1,
            y: 0,
            duration: 0.6,
            onComplete: () => {
              showEl.style.opacity = '';
              showEl.style.transform = '';
            },
          }
        );
      }
    };

    setActive(0, false);

    navLinks.forEach((li, i) => {
      const a = li.querySelector('a');
      if (a) {
        a.addEventListener('click', (e) => {
          e.preventDefault();
          setActive(i);
        });
      }
    });
  },
};
